import React, { createContext, useContext } from 'react';

const ConnectJSContext = createContext({});

export const useConnectJSContext = () => {
      return useContext(ConnectJSContext);
};

export const EmbeddedComponentProvider = ({ children, connectInstance }) => {
      return (
            <ConnectJSContext.Provider value={{ connectInstance }}>
                  {children}
            </ConnectJSContext.Provider>
      );
}; 